import { ApiResponse, useFetch } from '@/api/useFetch';
import CONSTANTS from '@/helpers/constants';
import { getProperQueryString } from '@/helpers/utils';
import {
  FreeServiceDetail,
  GetServiceDetailResponse,
  GetServiceOrderQueryParams,
  GetServiceOrderResponse,
  ReservedServiceResponse,
} from '@/pages/Service/Service.types';
import type { GetServicesQueryParams, GetServicesResponse } from '@/pages/Services/Services.types';
import { ApiMethod } from '@/types/enums';
import { ApiSuccessResponse, ServicePickerResponse } from '@/types/shared';

const { SERVICES } = CONSTANTS.API_ENTITY_URLS;

export const useGetServicePicker = async (): Promise<ApiResponse<ServicePickerResponse>> => {
  return useFetch(`api/${SERVICES}/picker`, {
    method: ApiMethod.Get,
  });
};

export const useGetServices = async (query: GetServicesQueryParams): Promise<ApiResponse<GetServicesResponse>> => {
  return await useFetch(`api/${SERVICES}?${getProperQueryString(query)}`, {
    method: ApiMethod.Get,
  });
};

export const useGetServiceInfo = async (serviceId: number): Promise<ApiResponse<GetServiceDetailResponse>> => {
  return await useFetch(`api/${SERVICES}/${serviceId}`, {
    method: ApiMethod.Get,
  });
};

export const useGetServicesHistory = async ({
  serviceId,
  query,
}: {
  serviceId: number;
  query: GetServiceOrderQueryParams;
}): Promise<ApiResponse<GetServiceOrderResponse>> => {
  return await useFetch(`api/${SERVICES}/${serviceId}/orders?${getProperQueryString(query)}`, {
    method: ApiMethod.Get,
  });
};

export const useGetReservedService = async (serviceId: number): Promise<ApiResponse<ReservedServiceResponse>> => {
  return await useFetch(`api/${SERVICES}/${serviceId}/reserve`, {
    method: ApiMethod.Get,
  });
};

export const useActiveReserveService = async (serviceId: number): Promise<ApiResponse<ApiSuccessResponse>> => {
  return await useFetch(`api/${SERVICES}/${serviceId}/reserve/activate`, {
    method: ApiMethod.Post,
  });
};

export const useActivateServices = async (serviceId: number): Promise<ApiResponse<ApiSuccessResponse>> => {
  return await useFetch(`api/${SERVICES}/${serviceId}/activate`, {
    method: ApiMethod.Post,
  });
};

export const useCreateFreeDemoService = async (): Promise<ApiResponse<FreeServiceDetail>> => {
  return await useFetch(`api/${SERVICES}/free`, {
    method: ApiMethod.Post,
  });
};

export const useGetStatusFreeDemoService = async (): Promise<ApiResponse<ApiSuccessResponse>> => {
  return await useFetch(`api/${SERVICES}/free/status`, {
    method: ApiMethod.Get,
  });
};
